"use client";

import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { useTranslations } from "next-intl";
import React, { useState } from "react";
import TestimonialForm from "./form/TestimonialForm";

const TestimonialDialog = () => {
  const t = useTranslations();
  const [open, setOpen] = useState(false);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button aria-label={t("Leave a Testimonial")}>
          {t("Leave a Testimonial")}
        </Button>
      </DialogTrigger>

      <DialogContent className="md:max-w-3xl rounded-[5px] p-10">
        <DialogTitle className="hidden" />
        <TestimonialForm onSuccess={() => setOpen(false)} />
      </DialogContent>
    </Dialog>
  );
};

export default TestimonialDialog;
